import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const NewsletterBox = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address");
      return;
    }
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed! Watch your inbox for wolfdog news.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="newsletter-box"
      className="bg-[#0A192F] text-white p-8 border-2 border-[#D4AF37]/60 relative overflow-hidden"
    >
      <div className="flex items-center gap-3 mb-3">
        <Mail className="w-6 h-6 text-[#D4AF37]" aria-hidden="true" />
        <h3 className="font-display text-2xl font-bold text-[#D4AF37]">Stay Informed</h3>
      </div>
      <p className="text-sm text-white/80 leading-relaxed mb-5">
        Get the latest news, legislation updates and important alerts delivered to your inbox.
      </p>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          data-testid="newsletter-input"
          className="flex-1 px-4 py-3 bg-white text-[#0A192F] outline-none focus:ring-2 focus:ring-[#D4AF37] placeholder:text-slate-400"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="px-6 py-3 bg-[#D4AF37] text-[#0A192F] font-semibold overline hover:bg-[#e6c14e] transition-colors disabled:opacity-60 shrink-0 whitespace-nowrap"
        >
          {loading ? "..." : "Subscribe"}
        </button>
      </form>
      <p className="mt-3 text-xs text-white/50">We respect your privacy. Unsubscribe anytime.</p>
    </div>
  );
};

export default NewsletterBox;
